import { useTranslation } from 'react-i18next'

import { Text } from '@mercai/clever'

import { ShowTotalProps } from './show-total.type'

import { formatCurrency } from '@/helpers'
import { SectionHeader } from '../section-header'
import styles from './show-total.module.css'

export const ShowTotal = ({
  total,
  currency,
  subtotal,
  iva,
  dollarExchangeRate,
  position,
  // isLoading,
}: ShowTotalProps) => {
  const { t } = useTranslation('screenSupplierOrderManagementComponents')
  return (
    <SectionHeader title={`${position}. ${t('componentShowTotalTitle')}`}>
      <div className={styles.core}>
        <div className={styles['dollar-exchange-rate']}>
          <div>
            <Text>{t('componentShowTotalDollarEschangeRateLabel')}</Text>
          </div>
          <div>
            <Text>
              <strong>
                1.00 USD ={' '}
                {formatCurrency(dollarExchangeRate || 0, 'es-MX', 'MXN', 5)}
              </strong>
            </Text>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles['card-item']}>
            <div>
              <Text>{t('componentShowTotalSubtotalLabel')}</Text>
            </div>
            <div>
              <Text>
                <strong>
                  {formatCurrency(subtotal || 0, 'es-MX', currency)}
                </strong>
              </Text>
            </div>
          </div>

          <div className={styles['card-item']}>
            <div>
              <Text>{t('componentShowTotalIvaLabel')}</Text>
            </div>
            <div>
              <Text>
                <strong>{formatCurrency(iva || 0, 'es-MX', currency)}</strong>
              </Text>
            </div>
          </div>

          <div className={styles['card-item-total']}>
            <div>
              <Text variant="title-large">
                {t('componentShowTotalTotalLabel')}
              </Text>
            </div>
            <div>
              <Text variant="title-large">
                {formatCurrency(total, 'es-MX', currency)}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </SectionHeader>
  )
}
